import styled from "styled-components";

interface InfoContainerProps {
  background?: string;
  alignCenter?: boolean;
}

export const InfoContainer = styled.div<InfoContainerProps>`
  width: calc(100vw - 320px);
  padding: 48px 160px;

  display: flex;
  flex-direction: column;

  background-color: ${(props) =>
    props.background === "blue"
      ? `var(--primary)`
      : `var(--lightest)`};

  .footer-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    text-align: center;

    margin-bottom: 48px;
  }

  .footer-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 48px;
  }

  .footer-bottom {
    margin-top: 48px;
    padding-top: 24px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;

    border-top: 1px solid rgba(255,255,255,.2);

    color: white;
    font-size: 0.875rem;
  }

  @media (max-width: 768px) {
    width: calc(100vw - 80px);

    padding: 32px 40px;

    .footer-grid {
      grid-template-columns: 1fr;
    }

    .footer-bottom {
      flex-direction: column;
      text-align: center;
    }
  }
`;

export const InstitutionalBadges = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  a {
    display: flex;
    align-items: center;
  }

  img {
    height: 40px;
    width: auto;
    border-radius: 4px;
    background-color: var(--lightest);
    padding: 4px 8px;
  }
`;

export const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  flex: 1;
`;

export const InfoTitle = styled.h3`
  color: var(--lightest);
  font-weight: 700;
  font-size: 1.25rem;
  margin: 0px;
`;

export const InfoDescription = styled.h4`
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--lightest);
  margin: 0;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const FooterLink = styled.a`
  text-decoration: none;
  color: var(--lightest);
  font-size: 0.875rem;
  font-weight: 700;
`;

export const AddressFooter = styled.footer`
  width: calc(100vw - 320px);
  display: flex;
  flex-direction: row;
  padding: 32px 160px;
  background-color: var(--lightest);
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 960px) {
    width: calc(100vw - 160px);
    padding: 32px 80px;
  }

  @media (max-width: 768px) {
    width: calc(100vw - 80px);
    flex-direction: column;
    padding: 32px 40px;
  }
`;

export const Address = styled.span`
  font-size: 1rem;
  color: var(--lightest);
  line-height: 1.6;
`;
